import { render } from "./VerifyEmailModal.vue?vue&type=template&id=0621f1c3&scoped=true"
import script from "./VerifyEmailModal.vue?vue&type=script&lang=js"
export * from "./VerifyEmailModal.vue?vue&type=script&lang=js"

import "./VerifyEmailModal.vue?vue&type=style&index=0&id=0621f1c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0621f1c3"]])

export default __exports__